import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import "@SupplyLand/Store/Components/FlyoutDrawerReducer";
import "@SupplyLand/Store/Pages/OnePageCheckout/SupplyLandOnePageCheckoutReducer";
import "@SupplyLand/Store/Reducers";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [350, 500, 720, 960, 1140],
    },
    typography: {
        fontFamilyImportUrl:
            "https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700;800;900&display=swap",
        body: {
            fontFamily: "'Montserrat', sans-serif",
        },
        headerPrimary: {
            fontFamily: "'Montserrat', sans-serif",
        },
        headerSecondary: {
            fontFamily: "'Montserrat', sans-serif",
        },
        headerTertiary: {
            fontFamily: "'Montserrat', sans-serif",
        },
    },
    focus: {
        style: "inherit",
        color: "inherit",
    },
});
